import {
  IRequirementResponse,
  RequirementExpirationStatus
} from "@wingspanhq/payments/dist/interfaces";

export const selectorIsRequirementBeforeExpiration = (
  requirement: IRequirementResponse
) => {
  return (
    requirement.expiresAt &&
    requirement.expirationStatus !== RequirementExpirationStatus.Expired &&
    requirement.expirationStatus !== RequirementExpirationStatus.Expiring
  );
};
